<!-- @format -->
<ul
	class="thumbnail-container hmf-display-flex hmf-align-items-center hmf-justify-content-start hmf-flex-lg-wrap hmf-m-0 hmf-px-0 hmf-pb-xxxs"
	role="list">
	<li
		*ngFor="let media of medias; let item = index; trackBy: trackByMedia"
		[ngClass]="{ selected: media.id === selected }"
		class="thumbnail"
		role="listitem">
		<button
			class="button-image-container hmf-p-0 hmf-sharp-radius"
			(click)="selectMedia(media, item)"
			tabindex="0">
			<picture
				class="hmf-display-flex hmf-align-items-center hmf-justify-content-center hmf-position-relative">
				<source
					type="image/webp"
					[srcset]="media.url"
					[attr.lazyLoad]="media.url" />
				<img
					ngSrc="media.url"
					[attr.aria-label]="media.video ? 'Video' : 'Image'"
					class="hmf-sharp-radius"
					alt="Thumbnail"
					loading="lazy" />

				@if (media.video) {
					<product-reviews-play-button
						class="hmf-position-absolute"></product-reviews-play-button>
				}
			</picture>
		</button>
	</li>
</ul>
